"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.card = void 0;
const tv_1 = require("../utils/tv");
exports.card = (0, tv_1.tv)({
  base: `flex flex-col items-center bg-primary p-4`,
  variants: {
    cardRounded: {
      true: `rounded-sm`,
      false: ``
    },
    cardShadow: {
      true: `shadow-sm`,
      false: ``
    },
    cardBordered: {
      true: '',
      false: ''
    },
    cardInteractive: {
      true: `
        focus-visible:border-keyboard-focus focus-visible:bg-brand-soft-active
      `,
      false: ``
    },
    cardDisabled: {
      true: `pointer-events-none opacity-60`
    }
  },
  compoundVariants: [{
    cardBordered: false,
    cardRounded: true,
    className: `border-md border-transparent`
  }, {
    cardBordered: false,
    cardRounded: false,
    className: `border-y-md border-transparent`
  }, {
    cardBordered: true,
    cardRounded: true,
    className: `border-md border-primary`
  }, {
    cardBordered: true,
    cardRounded: false,
    className: `border-y-md border-primary`
  }, {
    cardRounded: true,
    cardInteractive: true,
    className: `focus-visible:border-md`
  }, {
    cardRounded: false,
    cardInteractive: true,
    className: `focus-visible:border-y-md`
  }, {
    cardInteractive: true,
    cardRounded: false,
    cardBordered: false,
    className: `
        hover:border-y-md hover:border-primary hover:bg-primary
        active:border-y-md active:border-primary active:bg-brand-soft-active
      `
  }, {
    cardInteractive: true,
    cardRounded: true,
    cardBordered: false,
    className: `
        hover:border-md hover:border-primary hover:bg-primary
        active:border-md active:border-primary active:bg-brand-soft-active
      `
  }, {
    cardInteractive: true,
    cardBordered: true,
    cardRounded: true,
    className: `
        hover:border-md hover:border-secondary hover:bg-primary
        active:border-md active:border-secondary active:bg-brand-soft-active
      `
  }, {
    cardInteractive: true,
    cardBordered: true,
    cardRounded: false,
    className: `
        hover:border-y-md hover:border-secondary hover:bg-brand-soft
        active:border-y-md active:border-secondary active:bg-brand-soft-active
      `
  }],
  defaultVariants: {
    cardBordered: false,
    cardRounded: false,
    cardShadow: false,
    cardDisabled: false,
    cardInteractive: false
  }
});
